@let file = fileSg();
@let error = errorSg();
<div class="atn-ds-file">
  @let types = typesSg();
  @let acceptedTypes = types.length === 0 ? '*' : types.join(', ');
  @if (isUploadIconSg()) {
    <input
      #input
      class="atn-ds-file__input"
      type="file"
      [multiple]="false"
      [accept]="acceptedTypes"
      (change)="fileChangeHandler()"
    />
    <atn-ds-button
      type="transparent"
      [loading]="isUploadingSg()"
      (click)="input.click()"
      ><i class="atn-icon atn-upload atn-blue"></i
    ></atn-ds-button>
    @if (error) {
      <div class="atn-ds-file__error-display">
        <div
          class="atn-ds-file__error-content"
          [innerHTML]="error"
        ></div>
        <i
          class="atn-icon atn-close atn-blue"
          (click)="clearError()"
        ></i>
      </div>
    }
  } @else {
    <div
      #dropzone
      class="atn-ds-file__dropzone"
      [class.atn-ds-file__dropzone--error]="error"
      fileDragAndDrop
      [style.border-style]="file ? 'solid' : 'dashed'"
      (filesDropped)="fileDroppedHandler($event)"
    >
      <input
        #input
        class="atn-ds-file__input"
        type="file"
        [multiple]="false"
        [accept]="acceptedTypes"
        (change)="fileChangeHandler()"
      />
      @if (error) {
        <div class="atn-ds-file__error-display">
          <div
            class="atn-ds-file__error-content"
            [innerHTML]="error"
          ></div>
          <i
            class="atn-icon atn-close atn-blue"
            (click)="clearError()"
          ></i>
        </div>
      } @else {
        <div class="atn-ds-file__text-wrapper">
          @if (file) {
            <span>{{ file.name }}</span>
          } @else {
            <span>
              Drop a file or click
              <span
                class="atn-ds-file__text-wrapper--link"
                (click)="input.click()"
                >here</span
              >
              to select one
            </span>
          }
        </div>
      }
    </div>
  }
</div>
